// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip-component {
  color: var(--color-black);
  padding: 0px;
  border-radius: 0px;
}

.title-row {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-row .title {
  position: relative;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  vertical-align: middle;
  text-transform: none;
  margin: 0 auto;
}
.title-row .title::before, .title-row .title::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 50px;
  height: 2px;
  background: var(--color-black);
}
.title-row .title::before {
  transform: translate(-100%, 0px);
  left: 0%;
}
.title-row .title::after {
  transform: translate(100%, 0px);
  right: 0%;
}

.tip-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.title {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--color-black);
  margin-right: 10px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
}

.chip {
  width: -moz-fit-content;
  width: fit-content;
  padding: 5px 20px;
  text-align: start;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  border-radius: 16px;
}

.tip-img {
  height: 30px;
  width: 32px;
}

.tip {
  position: relative;
  height: 60px;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 1px solid var(--ion-color-dark);
  color: #fff;
  font-family: var(--ion-font-family);
  padding-top: 5px;
}
.tip .sum {
  font-family: var(--ion-font-family);
  font-size: 18px;
  font-weight: 700;
  line-height: 18.72px;
  text-align: center;
  vertical-align: middle;
  color: #383838;
}
.tip:last-of-type {
  margin-right: 0;
}
.tip .selected-checkmark {
  display: none;
}
.tip.selected {
  background: var(--ion-color-dark);
}
.tip.selected .sum {
  color: var(--ion-color-white);
}
.tip.selected .selected-checkmark {
  display: block;
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  width: 20px;
}

.dark-tip {
  position: relative;
  height: 60px;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #383838;
  border: 1px solid #383838;
  border-radius: 6px;
  color: #fff;
  font-family: var(--ion-font-family);
}
.dark-tip .sum {
  font-family: var(--ion-font-family);
  font-size: 18px;
  font-weight: 700;
  line-height: 18.72px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  padding-top: 5px;
}
.dark-tip:last-of-type {
  margin-right: 0;
}
.dark-tip .selected-checkmark {
  display: none;
}
.dark-tip.selected {
  background: #383838;
  border: 1px solid #E30613 !important;
}
.dark-tip.selected .selected-checkmark {
  display: block;
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  width: 20px;
}

.custom-tip-row {
  justify-content: space-between;
}
.custom-tip-row ion-icon {
  cursor: pointer;
}

.custom {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.titles-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.titles-wrapper p {
  margin-left: 15px;
}

.dismiss-tip {
  padding: 20px 0;
}
.dismiss-tip .dismiss-tip-btn {
  cursor: pointer;
  color: var(--ion-color-dark);
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 1%;
  text-align: center;
  vertical-align: middle;
  text-decoration: underline;
}
.dismiss-tip .dark {
  color: #fff;
}

.subtitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  color: #000;
}

.subtitle-one {
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-size: 16px;
}

.subtitle-two {
  font-family: var(--ion-font-family);
  font-weight: 400;
  font-size: 12px;
}

.dark-theme-subtitle {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tip/tip.component.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACD;AACC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;AACF;AACE;EAEC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;AAAH;AAGE;EACC,gCAAA;EAEA,QAAA;AAFH;AAIE;EACC,+BAAA;EACA,SAAA;AAFH;;AAOA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAJD;;AAOA;EACC,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAJD;;AAOA;EACC,uBAAA;EAAA,kBAAA;EACA,iBAAA;EAEA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AALD;;AAQA;EACC,YAAA;EACA,WAAA;AALD;;AAQA;EACC,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,uBAAA;EACA,uCAAA;EACA,WAAA;EACA,mCAAA;EACA,gBAAA;AAND;AAQC;EACC,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AANF;AASC;EACC,eAAA;AAPF;AASC;EACC,aAAA;AAPF;AAUC;EACC,iCAAA;AARF;AASE;EACC,6BAAA;AAPH;AAUE;EACC,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EAEA,YAAA;EACA,WAAA;AATH;;AAcA;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,mCAAA;AAZJ;AAcI;EACE,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACH,gBAAA;AAZH;AAeI;EACE,eAAA;AAbN;AAeI;EACE,aAAA;AAbN;AAgBI;EACE,mBAAA;EACA,oCAAA;AAdN;AAeM;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAbR;;AAkBA;EACC,8BAAA;AAfD;AAiBC;EACC,eAAA;AAfF;;AAkBA;EACC,aAAA;EACA,yBAAA;EACA,eAAA;AAfD;;AAkBA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AAfD;AAgBC;EACC,iBAAA;AAdF;;AAiBA;EACC,eAAA;AAdD;AAeC;EACC,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AAbF;AAgBE;EACE,WAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AAfF;;AAkBA;EACE,mCAAA;EACA,gBAAA;EACA,eAAA;AAfF;;AAkBA;EACE,mCAAA;EACA,gBAAA;EACA,eAAA;AAfF;;AAkBA;EACE,WAAA;AAfF","sourcesContent":[".tip-component {\n\tcolor: var(--color-black);\n\tpadding: 0px;\n\tborder-radius: 0px;\n}\n\n.title-row {\n\tposition: relative;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.title {\n\t\tposition: relative;\n\t\tfont-size: 24px;\n\t\tline-height: 120%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: none;\n\t\tmargin: 0 auto;\n\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\twidth: 50px;\n\t\t\theight: 2px;\n\t\t\tbackground: var(--color-black);\n\t\t}\n\n\t\t&::before {\n\t\t\ttransform: translate(-100%, 0px);\n\n\t\t\tleft: 0%;\n\t\t}\n\t\t&::after {\n\t\t\ttransform: translate(100%, 0px);\n\t\t\tright: 0%;\n\t\t}\n\t}\n}\n\n.tip-row {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n}\n\n.title {\n\tfont-family: AppFontSemiBold, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: var(--color-black);\n\tmargin-right: 10px;\n\ttext-transform: uppercase;\n\twidth: 100%;\n\ttext-align: center;\n}\n\n.chip {\n\twidth: fit-content;\n\tpadding: 5px 20px;\n\n\ttext-align: start;\n\tfont-size: 10px;\n\tline-height: 12px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\ttext-transform: uppercase;\n\tborder-radius: 16px;\n}\n\n.tip-img {\n\theight: 30px;\n\twidth: 32px;\n}\n\n.tip {\n\tposition: relative;\n\theight: 60px;\n\tmargin-right: 5px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: transparent;\n\tborder: 1px solid var(--ion-color-dark);\n\tcolor: #fff;\n\tfont-family: var(--ion-font-family);\n\tpadding-top: 5px;\n\n\t.sum {\n\t\tfont-family: var(--ion-font-family);\n\t\tfont-size: 18px;\n\t\tfont-weight: 700;\n\t\tline-height: 18.72px;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\tcolor: #383838;\n\t}\n\n\t&:last-of-type {\n\t\tmargin-right: 0;\n\t}\n\t.selected-checkmark {\n\t\tdisplay: none;\n\t}\n\n\t&.selected {\n\t\tbackground: var(--ion-color-dark);\n\t\t.sum {\n\t\t\tcolor: var(--ion-color-white);\n\t\t}\n\n\t\t.selected-checkmark {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 5px;\n\t\t\tright: 5px;\n\n\t\t\theight: 20px;\n\t\t\twidth: 20px;\n\t\t}\n\t}\n}\n\n.dark-tip {\n    position: relative;\n    height: 60px;\n    margin-right: 5px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    background: #383838;\n    border: 1px solid #383838;\n    border-radius: 6px;\n    color: #fff;\n    font-family: var(--ion-font-family);\n\n    .sum {\n      font-family: var(--ion-font-family);\n      font-size: 18px;\n      font-weight: 700;\n      line-height: 18.72px;\n      text-align: center;\n      vertical-align: middle;\n      color: #fff;\n\t  padding-top: 5px;\n    }\n\n    &:last-of-type {\n      margin-right: 0;\n    }\n    .selected-checkmark {\n      display: none;\n    }\n\n    &.selected {\n      background: #383838;\n      border: 1px solid #E30613 !important;\n      .selected-checkmark {\n        display: block;\n        position: absolute;\n        top: 5px;\n        right: 5px;\n        height: 20px;\n        width: 20px;\n      }\n    }\n  }\n\n.custom-tip-row {\n\tjustify-content: space-between;\n\n\tion-icon {\n\t\tcursor: pointer;\n\t}\n}\n.custom {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcursor: pointer;\n}\n\n.titles-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tp {\n\t\tmargin-left: 15px;\n\t}\n}\n.dismiss-tip {\n\tpadding: 20px 0;\n\t.dismiss-tip-btn {\n\t\tcursor: pointer;\n\t\tcolor: var(--ion-color-dark);\n\t\tfont-weight: 700;\n\t\tfont-size: 16px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 1%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-decoration: underline;\n\t}\n\n  .dark {\n    color: #fff;\n  }\n}\n\n.subtitle {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 2rem;\n  margin-bottom: 0.5rem;\n  color: #000\n}\n\n.subtitle-one {\n  font-family: var(--ion-font-family);\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.subtitle-two {\n  font-family: var(--ion-font-family);\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.dark-theme-subtitle {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
